import { useRef, useEffect, useState, useCallback } from 'react';

export function usePrevious<T>(value: T): T | undefined {
  const ref = useRef<T>(undefined);
  useEffect(() => {
    ref.current = value;
  }, [value]);

  return ref.current;
}

export function useStateCallback<S>(initialState: S) {
  const [state, setState] = useState(initialState);
  const cbRef = useRef<((state: S) => void) | null>(null);

  const setStateCallback = useCallback((state: S, cb?: (state: S) => void) => {
    if (cb) {
      cbRef.current = cb;
    }
    setState(state);
  }, []);

  useEffect(() => {
    if (cbRef.current) {
      cbRef.current(state);
      cbRef.current = null;
    }
  }, [state]);

  return [state, setStateCallback] as const;
}
